import { NavigationAnchor } from "@/components/layout/types";
import { Module, PATH_PAYROLLS } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { ClipboardClockIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export const usePayrollMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const payrollsPermissions = useModulePermissions(Module.Payrolls);
  const payrollTypesPermissions = useModulePermissions(Module.PayrollTypes);
  const config = getDictionaryConfig(Module.PayrollTypes);

  return [
    {
      icon: ClipboardClockIcon,
      url: PATH_PAYROLLS,
      permission: payrollsPermissions.can_read,
      title: t("payrolls.navigation.payrolls"),
    },
    {
      icon: config.Icon,
      url: config.path,
      title: config.getLabels(t).dict,
      permission: payrollTypesPermissions.can_read,
    },
  ];
};
